import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: '888 Sourcing provided invaluable support in navigating institutional procurement requirements in Africa. Their supplier verification process and market knowledge helped us secure our first major contract on the continent.',
    role: 'Export Director',
    company: 'European Industrial Equipment Manufacturer'
  }, {
    quote: 'Their understanding of cross-border sourcing and global supplier networks significantly accelerated our tender response. Professional, transparent, and consistently aligned with our compliance requirements.',
    role: 'Procurement Lead',
    company: 'Asia-Pacific Infrastructure Programme'
  }, {
    quote: "888 Sourcing's technical evaluation capabilities and ability to coordinate suppliers across Europe and Asia were critical to delivering our regional energy project on schedule.",
    role: 'Commercial Director',
    company: 'Middle East Energy Sector'
  }];
  return <section className="py-24 px-6 bg-navy-dark" data-id="element-281">
      <div className="max-w-7xl mx-auto" data-id="element-282">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-283">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-284">
            <div className="w-12 h-px bg-gold" data-id="element-285"></div>
            <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-286">
              Client Feedback
            </span>
            <div className="w-12 h-px bg-gold" data-id="element-287"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-4" data-id="element-288">
            What Our Partners Say
          </h2>
          <p className="text-slate-400 text-sm max-w-2xl mx-auto" data-id="element-289">
            Anonymised feedback from suppliers and procurement partners we have
            worked with
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-290">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-light border border-slate-800 p-8 rounded-lg" data-id="element-291">
              <QuoteIcon size={32} className="text-gold/30 mb-4" data-id="element-292" />
              <p className="text-slate-300 leading-relaxed mb-6 italic" data-id="element-293">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-slate-800 pt-4" data-id="element-294">
                <div className="text-white font-semibold" data-id="element-295">
                  {testimonial.role}
                </div>
                <div className="text-gold text-sm mt-1" data-id="element-296">
                  {testimonial.company}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}